import { render } from "./CustomNode.vue?vue&type=template&id=51dc32f3&scoped=true"
import script from "./CustomNode.vue?vue&type=script&lang=js"
export * from "./CustomNode.vue?vue&type=script&lang=js"

import "./CustomNode.vue?vue&type=style&index=0&id=51dc32f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dc32f3"]])

export default __exports__